import { z } from 'zod';
/** Largest file that can be attached to a task, task reply, wiki page or workspace post (t1249). */
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
/** Attached files (not counting pictures pasted into the text) per item. */
export const MAX_ATTACHMENTS_PER_ITEM = 10;
/** Picture types that may be pasted into rich text and shown inline. */
export const INLINE_IMAGE_CONTENT_TYPES = [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
];
/** What the upload endpoint returns, and what an item lists. `url` is a
 *  capability link — whoever holds it can fetch the file. */
export const attachmentSchema = z.object({
    id: z.uuid(),
    filename: z.string(),
    contentType: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    url: z.string(),
});
/** Files staged by the upload endpoint, named when an item is saved. */
export const attachmentIdsSchema = z.array(z.uuid()).max(MAX_ATTACHMENTS_PER_ITEM);
//# sourceMappingURL=attachments.js.map